export default {
    categoriasArray : []
}